import React from 'react';

import RegisterForm from './Form';

class RegisterPage extends React.Component {
  render() {
    return (
      <>
        <RegisterForm />
      </>
    );
  }
}

export default RegisterPage;